import React from 'react';
import { ListItem } from '@material-ui/core';

import styles from './BeneficiaryRow.module.css';

interface IBeneficiaryRow {
  id: string;
  onClick: (e:React.MouseEvent<HTMLDivElement>) => void;
  children: React.ReactNode;
}

const BeneficiaryRow = ({ id, onClick, children }: IBeneficiaryRow) => (
  <ListItem id={id} button onClick={onClick} className={styles.listRow} disableGutters>
    {children}
  </ListItem>
);

export default BeneficiaryRow;
